import React, { FC } from 'react';
import { Tooltip } from '@src/components/Tooltip';
import { LinkedIn as LinkedInComponent } from '@src/components/LinkedIn';
import { UserProfileLinkTypeEnum } from '@src/graphql/generated';
import { Props } from './props';
import './styles.scss';

export const LinkedIn: FC<Props> = ({ isUserVerified, hasRecruiterMessaged, linkedInUrl, onLinkedInClick }) => {
  if (hasRecruiterMessaged) {
    return (
      <div className="talent-feed-item-actions__item">
        <LinkedInComponent
          label="Linkedin"
          linkedInUrl={linkedInUrl}
          onClick={e => onLinkedInClick(e, linkedInUrl, UserProfileLinkTypeEnum.LINKEDIN)}
          wrapperClassName="talent-feed-item-actions-linkedin-item talent-feed-item-actions-linkedin-item--active"
        />
      </div>
    );
  }

  return (
    <div className="talent-feed-item-actions__item">
      <Tooltip
        placement="top"
        overlay={
          isUserVerified ? (
            <span>You can access LinkedIn after you have contacted the candidate.</span>
          ) : (
            <span>Talent has hidden their profile.</span>
          )
        }
      >
        <span>
          <LinkedInComponent label="Linkedin" wrapperClassName="talent-feed-item-actions-linkedin-item" />
        </span>
      </Tooltip>
    </div>
  );
};
